import { CancellationTablePage } from "./cancellationTable/cancellationTablePage";
import { CancellationFilterPage } from "./cancellationFilter/CancellationFilterPage";


import classes from "./cancellationListPage.module.css";

export const CancellationListPage = () => {
  return (
    <div className={classes.box}>
      <CancellationFilterPage />
      <CancellationTablePage />
    </div>
  );
};
